export type Dir = 'n' | 'e' | 's' | 'w';
export type Kind = 'ns' | 'ew' | 'ne' | 'nw' | 'se' | 'sw' | 'x' | 'start' | 'goal' | 'wall' | 'empty';
export type Tile = { kind: Kind; open?: Dir; fixed?: true };
export type Level = { id: string; pack: string; n: number; rows: number; cols: number; tiles: Tile[][]; target?: number; /** 공략 영상에서 걸린 초·오래 걸린 판(관리자에게만 표시) */ secs?: number | null; hard?: boolean; src?: { video: string; t: number; flags: string[]; warn?: string[] } };
export type LevelFile = { version: 1; levels: Level[] };

export const OPENS: Record<Kind, Dir[]> = {
  ns: ['n', 's'], ew: ['e', 'w'], ne: ['n', 'e'], nw: ['n', 'w'], se: ['s', 'e'], sw: ['s', 'w'], x: ['n', 'e', 's', 'w'],
  start: [], goal: [], wall: [], empty: [],
};
export const OPP: Record<Dir, Dir> = { n: 's', s: 'n', e: 'w', w: 'e' };
export const DELTA: Record<Dir, [number, number]> = { n: [-1, 0], s: [1, 0], e: [0, 1], w: [0, -1] };

export function opens(t: Tile): Dir[] {
  if (t.kind === 'start' || t.kind === 'goal') return t.open ? [t.open] : [];
  return OPENS[t.kind];
}

/** 홈 방향 집합(정렬된 문자열) → 종류. 예: 'ns' → ns, 'en' → ne */
export function kindFromDirs(dirs: Dir[]): Kind | null {
  const key = [...dirs].sort().join('');
  const map: Record<string, Kind> = { ns: 'ns', ew: 'ew', en: 'ne', nw: 'nw', es: 'se', sw: 'sw', ensw: 'x', '': 'wall' };
  return map[key] ?? null;
}

export function validateLevel(l: Level): string[] {
  const errs: string[] = [];
  if (l.rows < 3 || l.rows > 7 || l.cols < 3 || l.cols > 7) errs.push('size');
  if (l.tiles.length !== l.rows || l.tiles.some((r) => r.length !== l.cols)) errs.push('shape');
  const flat = l.tiles.flat();
  if (flat.filter((t) => t.kind === 'start').length !== 1) errs.push('start');
  if (flat.filter((t) => t.kind === 'goal').length !== 1) errs.push('goal');
  if (!flat.some((t) => t.kind === 'empty')) errs.push('no-empty');
  for (const t of flat) if ((t.kind === 'start' || t.kind === 'goal') && !t.open) errs.push(`${t.kind}-open`);
  return errs;
}
